import axios from 'axios'
import Vue from 'vue'
import { DateTime } from 'luxon'

export default {
  data () {
    return {
      loading: true,
      sort: [],
      search: '',
      filters: {},
      perPage: 10,
      pageNum: 1,
      listData: [],
    }
  },
  computed: {
    // has implicit dependencies on this.defaultSort and this.staticFilters
    combinedSort () {
      return this.sort.length ? this.sort : this.defaultSort ? this.defaultSort : []
    },
    combinedFilters () {
      const filterArray = Object.values(this.filters)
      return [...(this.staticFilters || []), ...filterArray]
    },
    pagination () {
      return {
        perPage: this.perPage,
        pageNum: this.pageNum,
      }
    },
    listPayload () {
      return {
        ...(this.combinedSort.length ? { sort: this.combinedSort } : {}),
        ...(this.combinedFilters.length ? { filter: this.combinedFilters } : {}),
        ...(this.search.trim().length ? { search: this.search } : {}),
        pagination: this.pagination,
      }
    },
  },
  methods: {
    fetchList (APIPath = this.listAPIPath) {
      this.loading = true
      return axios.post(APIPath, this.listPayload)
        .then((res) => {
          this.listData = res.data.data || []
          return res
        })
        .finally(() => { this.loading = false })
    },
    fetchListAndUpdateTotal () {
      return this.fetchList()
        .then((res) => {
          if (this.updateTotal) this.updateTotal(res.data.pagination.total)
          return res
        })
    },
    updateFilters (filter) {
      Vue.set(this.filters, filter.key, filter)
    },
    clearFilters () {
      Vue.set(this, 'filters', {})
    },
    updateSort ({ sortBy, sortDesc }) {
      if (sortBy.length) {
          const key = sortBy[0]
          const order = sortDesc[0] ? 'DESC' : 'ASC'
          this.sort = [{ key, order }]
      } else {
        this.sort = []
      }
    },
    updatePagination ({ perPage, pageNum }) {
      if (perPage) this.perPage = perPage
      if (pageNum) this.pageNum = pageNum
    },
    updateSearch (search) {
      this.search = search
    },
    handleUpdatePagination (payload) {
      this.updatePagination(payload)
      return this.fetchList()
    },
    handleUpdateSort (payload) {
      this.updateSort(payload)
      return this.fetchList()
    },
    handleUpdateSearch (payload) {
      this.updateSearch(payload)
      this.updatePagination({ pageNum: 1 })
      return this.fetchListAndUpdateTotal()
    },
    handleUpdateFilters (payload) {
      this.updateFilters(payload)
      this.updatePagination({ pageNum: 1 })
      return this.fetchListAndUpdateTotal()
    },
    handleClearFilters () {
      this.clearFilters()
      this.updatePagination({ pageNum: 1 })
      return this.fetchListAndUpdateTotal()
    },
    exportCSV (nameString) {
      const now = DateTime.local().toFormat('yyyyLLdd_HHmmss')
      const fileName = `${nameString}-${now}`
      const payload = { APIPath: `${this.listAPIPath}/csv`, payload: this.listPayload, fileName }
      this.$store.dispatch('getCSV', payload)
    },
  },
}
